/** Límite alineado con validación en backend (encargo-pdf). */
export const MAX_ENCARGO_CLAUSULAS = 60;

/**
 * Convierte 1…3999 a numeración romana (mayúsculas).
 * @param {number} n
 * @returns {string}
 */
export function romanNumeralFromInt(n) {
  const x = Math.floor(Number(n));
  if (!Number.isFinite(x) || x < 1) return "I";
  if (x > 3999) return String(x);
  const vals = [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1];
  const syms = ["M", "CM", "D", "CD", "C", "XC", "L", "XL", "X", "IX", "V", "IV", "I"];
  let num = x;
  let r = "";
  for (let i = 0; i < vals.length; i++) {
    while (num >= vals[i]) {
      r += syms[i];
      num -= vals[i];
    }
  }
  return r;
}

/** Etiqueta sugerida para la cláusula en posición `indice` (0-based): "I.-", "II.-", … */
export function etiquetaNumClausulaPorIndice(indice) {
  return `${romanNumeralFromInt(indice + 1)}.-`;
}

/**
 * Parsea el contenido guardado (JSON de cláusulas) para el editor visual.
 * @param {string} raw
 * @returns {Array<{ num: string, texto: string }> | null}
 */
export function parseEncargoFilasDesdeContenido(raw) {
  const s = String(raw || "").trim();
  if (!s) return null;
  try {
    const arr = JSON.parse(s);
    if (!Array.isArray(arr) || arr.length === 0) return null;
    const ok = arr.every(
      (x) => x && typeof x === "object" && typeof x.num === "string" && typeof x.texto === "string"
    );
    if (!ok) return null;
    return arr.map((x) => ({ num: x.num, texto: x.texto }));
  } catch {
    return null;
  }
}

/**
 * @param {Array<{ num: string, texto: string }>} filas
 * @returns {string}
 */
export function serializarEncargoFilasJson(filas) {
  const rows = (filas || []).map((r) => ({
    num: String(r.num != null ? r.num : "").trim(),
    texto: r.texto != null ? String(r.texto) : "",
  }));
  return JSON.stringify(rows);
}
